export default "__VITE_ASSET__3E2kvcqg__"